import { _system } from '@umu/ukit-lang';
import { getModuleData } from 'common/src/services';

// APP  调用环境检测
const UA = navigator.userAgent;
const IOS_UA_ARR = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
const ANDROID_UA_ARR = navigator.userAgent.match(/Android (\d+)\.(\d+)?/i);
const browser = {
    isAndroid: !!UA.match(/android/gi),
    isAndroidGte6: ANDROID_UA_ARR && parseInt(ANDROID_UA_ARR[1], 10) > 5 ? true : false, // 安卓版本大于等于6
    isIos: !!UA.match(/iphone|ipod/gi),
    isIosGte9: IOS_UA_ARR && parseInt(IOS_UA_ARR[1], 10) > 8 ? true : false, // IOS版本是否大于等于9
    isWeixin: !!UA.match(/MicroMessenger/gi),
    isQQ: !!UA.match(/TBS/gi),
    isChrome: !!UA.match(/chrome\/(\d+\.\d+)/gi),
};

/**
 * 获取下载应用程序的链接
 *
 * @returns {string} 返回一个包含当前站点和时间戳的下载链接
 */
export function getDownloadAppLink() {
    const siteHost = getModuleData('siteHost');
    return '//' + siteHost + '/download/app/unknown?' + new Date().getTime();
}

// 基础配置
function getBaseConfig() {
    const siteHost = getModuleData('siteHost');
    const urlProtocol = 'https://www.';
    const stamp = new Date().getTime();
    let appLinkOnline = urlProtocol + 'umu.com/download/app/unknown?' + stamp;
    if (_system('CN')) {
        appLinkOnline = urlProtocol + 'umu.cn/download/app/unknown?' + stamp;
    } else if (_system('TW')) {
        appLinkOnline = urlProtocol + 'umu.tw/download/app/unknown?' + stamp;
    } else if (_system('JP')) {
        appLinkOnline = urlProtocol + 'umu.co/download/app/unknown?' + stamp;
    } else if (_system('EM')) {
        appLinkOnline = urlProtocol + 'umu.io/download/app/unknown?' + stamp;
    }

    const qqAPPDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.tc.umu&g_f=991653';
    const qqAPPEntDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.tc.umu.ent&g_f=991653';
    // const qqAPPDownloadUrl = 'https://static-file.umu.cn/app-download/Android/umu.apk';
    return {
        scheme: 'umu://', // 应该必填，考虑低版本IOS和安卓
        androidScheme: null, // 安卓用Scheme，以防万一安卓与IOS定义的不一致的时候可用，:D
        iosScheme: null, // IOS 用scheme
        params: null, // 参数，url里的查询字符串
        applink: appLinkOnline, // 安卓
        universalLink: appLinkOnline, // IOS
        qqAPPDownloadUrl, // umu通用版应用宝地址
        qqAPPEntDownloadUrl, // umu企业版应用宝地址
        downloadUrl: '//' + siteHost + '/download/app/unknown', // 应用下载地址
        // androidIntent: null,
        // Android Intent 方式唤起，尽量不用，该方式能用，scheme方式都能用
        timeout: 1600, // 超时时间
        autoCall: false, // 是否自动唤起
        appKind: 'general', // app版本类型，通用版
        success() {
            return;
        },
        error() {
            return;
        },
    };
}

class OpenApp {
    public _url: string;
    public _config: any;
    constructor(config: any = {}) {
        // 考虑改用深拷贝？
        this._config = this._mergeObjects(getBaseConfig(), config);

        if (typeof config === 'string') {
            this._url = config;
        } else if (this._config.androidScheme && browser.isAndroid) {
            this._url = this._config.androidScheme;
        } else if (this._config.iosScheme && browser.isIos) {
            this._url = config.iosScheme;
        } else {
            this._url = this._config.scheme;
        }

        // 如果采用deep link
        // 安卓针对6.0+
        // IOS针对9.0+
        if (browser.isAndroid && browser.isAndroidGte6 && this._config.applink) {
            this._url = this._config.applink;
        } else if (browser.isIos && browser.isIosGte9 && this._config.universalLink) {
            this._url = this._config.universalLink;
        }
        // 如果有查询参数
        if (this._config.params) {
            this._url += '?' + this._buildQueryString(this._config.params);
        }

        // 如果需要自动唤起
        if (this._config.autoCall) {
            this.run();
        }
    }

    /**检测是否唤起成功
     * 基于时间差来判断是否唤起成功，不太准确
     * 假定超时时间设为1600ms，判断基准为800ms
     * 如果没有唤起成功，停留在当前页，则当计数完毕后，时间差应该不会超过太多
     * 相反，如果唤起成功，则浏览器进入后台工作，setInterval会被延迟执行，时间差会被拉大,
     * 一些国产浏览器或者safari会在唤起的时候弹窗，导致此方法无效，考虑以下解决方案：
     * 1、对于Android国产浏览器，如果因为弹窗超时，则判定为失败，自动跳转下载页，但是由于弹窗还存在，如果用户点击唤起，依然可以唤起APP
     * 2、对于IOS,IOS7、8依旧采用scheme,IOS9+可以考虑使用universalLink！！
     */
    public _checkApp(cb: (bo: boolean) => void) {
        const timeout = this._config.timeout;
        const totalCount = Math.ceil(timeout / 20);
        const acceptTime = timeout + 800;

        const _callTime = +new Date(); // 开始调用时间
        let _count = 0; // 计数，20ms记一次
        let timer: any = null; // 定时器
        timer = setInterval(() => {
            _count++;
            const elsTime = +new Date() - _callTime;
            if (_count >= totalCount || elsTime > acceptTime) {
                clearInterval(timer);
                if (elsTime > acceptTime || document.hidden) {
                    if (cb) {
                        cb(true);
                    }
                } else {
                    if (cb) {
                        cb(false);
                    }
                }
            }
        }, 20);
    }

    // 唤起app
    public run(cb?: (isSuccess?: boolean) => void) {
        const successfn = this._config.success;
        const errorfn = this._config.error;
        // 检测唤起状态
        this._checkApp((flag: boolean) => {
            if (cb) {
                cb(flag);
            }
            if (flag) {
                if (successfn) {
                    successfn();
                }
            } else {
                if (errorfn) {
                    errorfn();
                }
            }
        });

        // 根据不同的浏览器来使用不同的唤起方式
        if (browser.isAndroid) {
            // 安卓里如果在微信内则直接打开应用宝，后面的事就不用管了
            if (browser.isWeixin || browser.isQQ) {
                window.location.href =
                    this._config.appKind === 'ent' ? this._config.qqAPPEntDownloadUrl : this._config.qqAPPDownloadUrl;
                return;
            } else if (browser.isChrome) {
                this._callAlink();
                return;
            }
            this._callIframe();
            return;
        } else if (browser.isIos) {
            this._callAlink();
        }
    }

    // a.href方式
    public _callAlink() {
        const alink = document.createElement('a');
        alink.href = this._url;
        alink.click();
    }

    // iframe.src 方式
    public _callIframe() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = this._url;
        document.body.appendChild(iframe);
    }

    // location 方式
    public _callLocation() {
        location.href = this._url;
    }

    // 构建查询字符串
    public _buildQueryString(obj: any = {}) {
        const keys = Object.keys(obj);
        const queryArr = keys.map((k) => {
            let v = obj[k];
            if (!Array.isArray(v) && typeof v === 'object') {
                v = JSON.stringify(v);
            }
            return k + '=' + v;
        });
        return queryArr.join('&');
    }

    public _mergeObjects(...arg: any[]) {
        const resObj: any = {};
        for (let i = 0; i < arg.length; i += 1) {
            const obj = arg[i];
            const keys = Object.keys(obj);
            for (let j = 0; j < keys.length; j += 1) {
                resObj[keys[j]] = obj[keys[j]];
            }
        }
        return resObj;
    }
}

export default OpenApp;
